<template>
  <div>

    <vs-popup :title="$t('CreateWebhook')" :active.sync="InWebhookPopup" v-if="InWebhookPopup">
      <div class="vx-col w-full mb-base">
        {{ $t('Title') }}:
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                  :label-placeholder="$t('Title') + ':'"
                  v-model="webhookTitle" />
      </div>
      <div class="vx-col w-full mb-base">
        {{ $t('URL') }}:
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                  :label-placeholder="$t('URL') + ':'"
                  v-model="webhookUrl" />
      </div>
      <div class="vx-col w-full mb-base">
        {{ $t('EventType') }}:
        <v-select :placeholder="$t('Select') + '..'"
                  label="type"
                  :closeOnSelect="true"
                  v-model="webhookEventType"
                  :clearable="false"
                  :reduce="(item) => item.id"
                  :options="eventTypes" />
      </div>

      <HeadersList ref="headersList"></HeadersList>

      <vs-button v-if="!IsInEditWebhookMode"
                 @click="CreateWebhook"
                 ref="createWebhookButton"
                 color="success"
                 style="width:100px; float:right;">
        {{ $t('Save') }}
      </vs-button>

      <vs-button v-if="IsInEditWebhookMode"
                 @click="CreateWebhook"
                 ref="createWebhookButton"
                 color="success"
                 style="width:130px; float:right;">
        {{ $t('SaveChanges') }}
      </vs-button>
    </vs-popup>
    <!--<vs-popup title="MagicLink" :active.sync="InMagicLinkPopup" v-if="InMagicLinkPopup">
      <div>
        <div class="vx-row">
          <div class="vx-col w-1/1">
            This is the registration link for users.
          </div>
          <div class="vx-col w-1/1">
            <vs-input v-model="magicLinkRegistration" style=""></vs-input>
            <vs-button color="dark" @click="CopyLink" type="line" style="float:left;" icon-pack="feather" icon="icon-copy" icon-after></vs-button>
          </div>
        </div>
      </div>
    </vs-popup>-->
    <vs-tabs>
      <vs-tab :label="$t('Database')">
        <vs-button @click="DownloadDatabase">{{ $t('DownloadDatabase') }}</vs-button>
        <vs-button @click="DownloadVersionHistoryDatabase">{{ $t('DownloadVersionHistoryDatabase') }}</vs-button>
      </vs-tab>
      <vs-tab label="Indexes">
        <vs-button @click="ReindexOnboardings">Reindex Onboarding</vs-button>
      </vs-tab>
      <vs-tab :label="$t('SystemSettings')">
        <MonacoEditor ref="editor" suffix="prop" :text_value="editor_value"></MonacoEditor>
        <vs-button @click="SaveChanges"
                   ref="markAsCompletedButton"
                   color="success" id="btn-complete"
                   class=""
                   style="width:100px; float:right;">
          {{ $t('Save') }}
        </vs-button>
      </vs-tab>
      <vs-tab :label="$t('ChangeLanguage')">
        <i18nAdmin></i18nAdmin>
      </vs-tab>
      <vs-tab :label="$t('CreateMagicLink')">
        <div class="magic-link-container" style="min-height: 300px;">
          <div>
            {{ $t('FilterByRoles') }}:
            <v-select :placeholder="$t('Select') + '..'"
                      label="name"
                      :closeOnSelect="true"
                      v-model="selectedRole"
                      :clearable="false"
                      :reduce="(item) => item.id"
                      :options="rolesList" />
          </div>
          <div class="vx-col w-full mb-base">
            {{ $t('MagicLink') }}:
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('MagicLink') + ':'"
                      v-model="magicLink" />
          </div>
          <div class="vx-col w-full mb-base">
            {{ $t('CampaignName') }}:
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('CampaignName') + ':'"
                      v-model="campaignName" />
          </div>
          <vs-button @click="CreateMagicLink"
                     ref="magicLinkButton"
                     color="success" id="btn-complete"
                     class=""
                     style="width:100px; float:right;">
            {{ $t('Save') }}
          </vs-button>
        </div>

        <!-- Existing Magic Links Section -->
        <div class="magic-link-tokens-container" style="margin-top: 30px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
            <h3 style="margin: 0;">{{ $t('ExistingMagicLinkTokens') }}</h3>
            <vs-button @click="LoadMagicLinkTokens"
                       ref="refreshTokensButton"
                       color="primary" type="relief"
                       icon-pack="feather" icon="icon-refresh-cw"
                       size="small">
              {{ $t('Refresh') }}
            </vs-button>
          </div>

          <div v-if="magicLinkTokens.length === 0 && !loadingTokens" class="no-tokens-message" style="text-align: center; padding: 20px; color: #666;">
            <p>{{ $t('NoMagicLinkTokensFound') }}</p>
          </div>

          <vs-button v-if="magicLinkTokens.length === 0 && !loadingTokens"
                     @click="LoadMagicLinkTokens"
                     :disabled="loadingTokens"
                     color="primary" type="line">
            <span v-if="loadingTokens">{{ $t('Loading') }}...</span>
            <span v-else>{{ $t('LoadTokens') }}</span>
          </vs-button>

          <div v-if="magicLinkTokens.length > 0" class="tokens-list">
            <vs-table :data="magicLinkTokens" class="mb-base">
              <template slot="thead">
                <vs-th sort-key="date">{{ $t('DateCreated') }}</vs-th>
                <vs-th sort-key="targetAudience">{{ $t('TargetURL') }}</vs-th>
                <vs-th sort-key="metadata">{{ $t('CampaignName') }}</vs-th>
                <vs-th sort-key="token">{{ $t('RoleToken') }}</vs-th>
                <vs-th>{{ $t('Actions') }}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    {{ formatDate(tr.date) }}
                  </vs-td>
                  <vs-td>
                    <span class="text-url" style="word-break: break-all;">{{ tr.targetAudience }}</span>
                  </vs-td>
                  <vs-td>
                    {{ tr.metadata || 'N/A' }}
                  </vs-td>
                  <vs-td>
                    <vs-chip color="primary">{{ tr.token }}</vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-button @click="copyToken(tr.targetAudience + '?roleId=' + tr.token)"
                               color="primary" type="relief"
                               icon-pack="feather" icon="icon-copy"
                               size="small">
                      {{ $t('CopyLink') }}
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <div v-if="loadingTokens" style="text-align: center; padding: 20px;">
            <vs-loading></vs-loading>
            <p>{{ $t('LoadingMagicLinkTokens') }}</p>
          </div>
        </div>
      </vs-tab>

      <vs-tab :label="$t('Webhooks')">
        <div class="block block mb-4">
          <vs-button @click="OpenWebhookCreationMenu"
                     color="success"
                     style="width:200px; float:right;">
            {{ $t('CreateWebhookButton') }}
          </vs-button>
        </div>
        <div style="clear:both"></div>
        <vs-table :data="webhooks">
          <vs-tr v-if="webhooks.length > 0">
            <vs-th>{{ $t('Title') }}</vs-th>
            <vs-th>{{ $t('URL') }}</vs-th>
            <vs-th>{{ $t('EventType') }}</vs-th>
            <vs-th>{{ $t('Actions') }}</vs-th>
          </vs-tr>
          <vs-tr v-for="(webhook, index) in webhooks" :key="index">
            <vs-td>{{ webhook.Title }}</vs-td>
            <vs-td>{{ webhook.URL }}</vs-td>
            <vs-td>{{GetEventType(webhook.EventType)}}</vs-td>
            <vs-td>
              <div class="flex">
                <vs-button color="warning" @click="EditWebhookData(webhook)" icon="edit" size="small" />
                <vs-button color="danger" @click="DeleteWebhook(webhook.Id,index)" icon="delete" size="small" class="ml-2" />
              </div>
            </vs-td>
          </vs-tr>
        </vs-table>

      </vs-tab>

      <vs-tab :label="$t('CreateEmbedScript')">
        <MonacoEditor ref="editor2"
                      suffix="prop2"
                      :text_value="script_value"
                      language="javascript"
                      :options="{
            theme: 'vs-dark',
            automaticLayout: true,
            formatOnPaste: true,
            formatOnType: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            fontSize: 14,
            tabSize: 2,
            wordWrap: 'on',
            folding: true,
            lineNumbers: 'on',
            renderWhitespace: 'selection',
            scrollbar: {
              vertical: 'visible',
              horizontal: 'visible'
            }
          }"
                      @editorDidMount="handleEditorDidMount"></MonacoEditor>
        <div style="margin-top: 10px;">
          <vs-button @click="formatDocument"
                     color="primary"
                     style="margin-right: 10px;">
            {{ $t('FormatDocument') }}
          </vs-button>
          <vs-button @click="EditInjectScript"
                     ref="editInjectScriptButton"
                     color="success"
                     style="width:100px; float:right;">
            {{ $t('Save') }}
          </vs-button>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import MonacoEditor from '@/views/components/extra-components/editors/MonacoEditor.vue';
  import i18nAdmin from '@/views/components/extra-components/i18n_admin.vue';
  import HeadersList from '@/views/ui-elements/list/HeadersList.vue';
  import vSelect from "vue-select";

  export default {
    data() {
      return {
        InMagicLinkPopup: false,
        InWebhookPopup: false,
        IsInEditWebhookMode: false,
        webhook_mode: "create",
        editor_value: null,
        script_value: null,
        scriptName: "",
        magicLink: "",
        rolesList: "",
        campaignName: "",
        selectedRole: null,
        editor: null,
        webhooks: [],
        magicLinkRegistration: "",
        webhookId: 0,
        webhookUrl: "",
        webhookTitle: "",
        webhookEventType: 0,
        magicLinkTokens: [],
        loadingTokens: false,
      };
    },
    props: {
      eventTypes: {
        type: Array,
        default() {
          return [
            {
              id: 0,
              type: "Step Completed"
            },
            {
              id: 1,
              type: "SOP Completed"
            },
            {
              id: 2,
              type: "Step Flagged"
            },
            {
              id: 3,
              type: "Request for documentation received"
            },
            {
              id: 4,
              type: "SOP saved"
            },
            {
              id: 5,
              type: "User Changed"
            },
            {
              id: 6,
              type: "User Deleted"
            }
          ];
        }
      },
    },

    mounted() {
      //this.GetSettings()
      this.editor_value = JSON.stringify(this.$systemSettings, null, 3)
      this.GetInjectScriptCode();
      this.LoadUsersAndRoles()
      this.LoadWebhooks();
      this.LoadMagicLinkTokens();
    },
    components: {
      MonacoEditor,
      vSelect,
      HeadersList,
      i18nAdmin
    },
    methods: {
      handleEditorDidMount(editor) {
        this.editor = editor;
      },

      formatDocument() {
        if (this.editor) {
          this.editor.getAction('editor.action.formatDocument').run();
        }
      },


      OpenWebhookCreationMenu() {
        if (this.IsInEditWebhookMode == true) {
          this.ClearWebhookData()
          this.IsInEditWebhookMode = false
        }
        this.InWebhookPopup = true;
      },

      DownloadDatabase() {
        var instance = this
        TCVelikClient.GetRelative("/api/admin/DownloadDatabase",
          {
            responseType: 'blob'
          }
        ).then(function (response) {
          if (response && response.data) {
            const blob = new Blob([response.data]);
            const link = document.createElement('a');
            link.download = `${"TCVNano"}`;
            link.href = URL.createObjectURL(blob);
            link.click();
          }

        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredDownloading'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      DownloadVersionHistoryDatabase() {
        var instance = this
        TCVelikClient.GetRelative("/api/admin/DownloadVersionHistoryDatabase",
          {
            responseType: 'blob'
          }
        ).then(function (response) {
          if (response && response.data) {
            const blob = new Blob([response.data]);
            const link = document.createElement('a');
            link.download = `${"VersionHistoryDatabase"}`;
            link.href = URL.createObjectURL(blob);
            link.click();
          }

        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredDownloading'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      ReindexOnboardings() {
        var instance = this
        instance.$vs.notify({
          title: "Reindexing Onboardings...",
          color: "success",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-check-circle",
        });
        TCVelikClient.PostRelative("/api/reindex" , {
        }).then(function (response) {
          if (response.status == 200) {
            instance.$vs.notify({
              title: "Reindexed Onboardings",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }

        }).catch(err => {
          instance.$vs.notify({
            title: "Something went wrong",
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      SaveChanges() {
        var instance = this
        var settings = instance.$refs.editor.getValue()
        TCVelikClient.PostRelative("/api/admin/UpdateSystemSettings", JSON.stringify(settings), {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.status == 200) {
            instance.editor_value = instance.$refs.editor.getValue()
            instance.$vs.notify({
              title: instance.$t('SuccessfullyUpdatedSettings'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }

        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredSaving'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      CreateMagicLink() {
        var instance = this
        TCVelikClient.PostRelative("/api/admin/GenerateMagicLink?link=" + instance.magicLink + '&roleId=' + instance.selectedRole + '&campaignName=' + instance.campaignName, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.status == 200) {
            instance.magicLink = ""
            instance.campaignName = ""
            //instance.InMagicLinkPopup = true;
            //instance.magicLinkRegistration = str
            instance.$vs.notify({
              title: instance.$t('SuccessfullyCreatedMagicLink'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            // Refresh the tokens list
            instance.LoadMagicLinkTokens();
          }

        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredSaving'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      LoadMagicLinkTokens() {
        var instance = this
        instance.loadingTokens = true;
        
        const query = {
          query: `query {
            magicLinkTokens {
              id
              date
              targetAudience
              metadata
              token
            }
          }`
        };
        
        console.log("GraphQL Query:", query);
        
        TCVelikClient.PostRelative("/api/graphql", query, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          console.log("GraphQL Response:", response);
          console.log("Response data:", response.data);
          
          if (response.data && response.data.data) {
            console.log("Magic link tokens:", instance.magicLinkTokens);
            instance.magicLinkTokens = response.data.data.magicLinkTokens || [];
            console.log("Magic link tokens after assignment:", instance.magicLinkTokens);
          } else {
            console.log("No data in response");
            instance.magicLinkTokens = [];
          }
          instance.loadingTokens = false;
        }).catch(err => {
          console.error("Error loading magic link tokens:", err);
          console.error("Error details:", err.response ? err.response.data : err);
          instance.magicLinkTokens = [];
          instance.loadingTokens = false;
          instance.$vs.notify({
            title: instance.$t('FailedToLoadMagicLinkTokens'),
            text: err.response ? err.response.data.message || "Unknown error" : "Network error",
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      formatDate(dateString) {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
      },

      copyToken(link) {
        navigator.clipboard.writeText(link).then(() => {
          this.$vs.notify({
            title: this.$t('LinkCopiedToClipboard'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }).catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = link;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          this.$vs.notify({
            title: this.$t('LinkCopiedToClipboard'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      async CreateWebhook() {
        var instance = this
        var headers = await instance.$refs.headersList.getValue()
        TCVelikClient.PostRelative("/api/admin/CreateWebhook", {
          Id: instance.webhookId,
          Title: instance.webhookTitle,
          URL: instance.webhookUrl,
          Headers: headers,
          EventType: instance.webhookEventType,
        }).then(function (response) {
          if (response.status == 200) {
            //instance.InMagicLinkPopup = true;
            //instance.magicLinkRegistration = str
            instance.$vs.notify({
              title: instance.$t('SuccessfullyCreatedWebhook'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.LoadWebhooks();
          }

        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredCreating'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      EditWebhookData(webhook) {
        this.IsInEditWebhookMode = true
        this.InWebhookPopup = true;
        this.webhookId = webhook.Id
        this.webhookUrl = webhook.URL
        this.webhookTitle = webhook.Title
        this.webhookEventType = webhook.EventType
        this.$nextTick(() => {
          this.$refs.headersList.setHeaders(webhook.Headers)
        });
      },

      ClearWebhookData() {
        this.webhookId = 0;
        this.webhookUrl = ""
        this.webhookTitle = ""
        this.webhookEventType = 0
      },

      LoadWebhooks() {
        var instance = this
        TCVelikClient.GetRelative("/api/admin/LoadWebhooks", {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.status == 200) {
            instance.webhooks = response.data
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredFetching'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      GetEventType(index) {
        return this.eventTypes[index].type
      },

      DeleteWebhook(id, index) {
        var instance = this;
        TCVelikClient.PostRelative("/api/admin/DeleteWebhook?id=" + id)
          .then(function (response) {
            if (response.status == 200) {
              instance.webhooks.splice(index, 1)
              instance.$vs.notify({
                title: instance.$t('SuccessfullyDeletedWebhook'),
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }

          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('ProblemOccurredDeleting'),
              color: "failure",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          });
      },

      CopyLink() {
        var instance = this;
        this.$copyText(this.magicLinkRegistration).then(
          function () {
            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              text: instance.$t('TextCopiedSuccessfully'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })
      },

      LoadUsersAndRoles() {
        var instance = this;
        const query = `
     query RolesWithUsers {
           rolesWithUsers {
               id
               name,
              }
       }`;
        const req = {
          query,
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response.data.data) {
            instance.rolesList = response.data.data.rolesWithUsers
            instance.selectedRole = response.data.data.rolesWithUsers[0].id
          }
        }).catch(err => {
          alert(instance.$t('ErrorFetchingRoles'))
        })
      },

      GetInjectScriptCode() {
        var instance = this
        TCVelikClient.GetRelative("/api/admin/GetInjectScriptCode", {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.status == 200) {
            instance.script_value = response.data;
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredLoading'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      EditInjectScript() {
        var instance = this;
        var settings = instance.$refs.editor2.getValue();

        TCVelikClient.PostRelative("/api/admin/EditInjectScript", JSON.stringify(settings), {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response) {
            instance.script_value = settings;
            instance.$vs.notify({
              title: instance.$t('SuccessfullyUpdatedSettings'),
              text: instance.$t('SafelyReloading'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemOccurredSaving'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      }
    }

  };
</script>

